import { Component } from 'react'
import { connect } from 'react-redux'
import Actions from '../../actions'
import ShiftPasswordForm from '../forms/popups/ShiftPasswordForm'
import Modal from '.'
import PopupModal from './PopupModal'

interface Shift {
  id: string
  // Define other properties of the Shift object
}

interface EditShiftModalProps {
  fields: Shift
  isOpen: boolean
  updateItem: (data: any) => void
  clearPassword: () => void
  showToast: (options: { title: string }) => void
  fetchList: (list: string) => void
}

const FORM_ID = 'editShift'

export class EditShiftModal extends Component<EditShiftModalProps> {
  handleSubmit = () => {
    const { fetchList, fields, showToast, updateItem } = this.props
    updateItem({
      url: `list/shifts/${fields.id}`,
      onComplete: () => {
        showToast({ title: 'Updated a Shift' })
        fetchList('shifts')
      }
    })
  }

  render() {
    const { clearPassword, fields, isOpen, ...formProps } = this.props

    if (!isOpen) return null
    return (
      <PopupModal
        confirmText="Save"
        includesRequired
        list="Shift"
        onConfirm={this.handleSubmit}
        type="edit"
        buttonIcon="CheckOutlined"
        buttonColour="success"
        {...formProps}
      >
        <ShiftPasswordForm
          fields={fields}
          formId={FORM_ID}
          onCancelEditPassword={clearPassword}
          type="edit"
        />
      </PopupModal>
    )
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    clearPassword: () =>
      dispatch(
        Actions.clearFormFields({
          fields: ['password', 'password_confirm'],
          formId: FORM_ID
        })
      )
  }
}

const wrappedModal = connect(null, mapDispatchToProps)(EditShiftModal)

export default Modal(wrappedModal, FORM_ID)
